<template>
  <div class="table-content">
    <div class="header">
      <div class="tab-list">
        <el-tabs v-model="payType" @tab-click="onPageChange({ page: 1 })">
          <el-tab-pane :name="item.name" :label="item.label" v-for="(item, index) in tabData" :key="index"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="search-content">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- <el-form-item style="float:right;">
            <el-button type="info"><i class="icon icon-export-excel "></i>导出 Excel</el-button>
          </el-form-item> -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.keyword" :placeholder="$t('pay_order.jiao_yi_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="table-bd">
      <custom-table
        tableCode="portal_pay_order"
        height="100%"
        :stripe="true"
        :data="tableList"
        @column="setColumn"
        columnRef="column"
        :slots="['tradeMethod', 'action']"
        @filter="filterChange"
        @sort="sortChange"
      >
        <template v-slot:tradeMethod="scope">
          <span class="trade-method">{{ getTradeMethod(scope.row) }}</span>
        </template>
        <template v-slot:action="scope">
          <span class="action-content">
            <el-button type="text" size="mini" @click="payRegister(scope.row)" v-if="funcView.account_register_payment && [1, 90].includes(scope.row.tradeState)">{{ $t('pay_order.que_ren_fu_kuan') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.account_cancel_payment && [1, 90].includes(scope.row.tradeState) && !scope.row.isLockBill" @click="onCancelOrder(scope.row)">
              {{ $t('pay_order.qu_xiao_fu_kuan') }}
            </el-button>
            <el-button type="text" size="mini" v-if="funcView.account_nullify_payment && [6].includes(scope.row.tradeState)" @click="onRevokeOrder(scope.row)">
              {{ $t('pay_order.che_xiao_fu_kuan') }}
            </el-button>
            <el-button type="text" size="mini" v-if="funcView.account_check_payment_record && [6, 10, 100].includes(scope.row.tradeState)" @click="checkPaymentInfo(scope.row)">
              {{ $t('pay_order.fu_kuan_xiang_qing') }}
            </el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="page-footer">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" :sizes="false" radius></custom-pagination>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import mixins from './mixins';

const tradeStateMap = {
  // 所有
  all: [],
  // 待支付
  wait: [1, 6, 90],
  // 已支付
  paid: [10, 100],
};

export default {
  name: 'payOrder',
  mixins: [mixins],
  components: {},
  props: {},
  data() {
    return {
      // 支付类型: 全部：all 待支付：wait 已支付：paid
      payType: '',
      formSearch: {
        keyword: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: 1,

      tableList: [],
      waitPayNum: 0,
    };
  },
  computed: {
    tabData() {
      const waitPayNum = this.waitPayNum;
      return [
        {
          name: 'all',
          label: this.$t('Common.com_all'),
        },
        {
          name: 'wait',
          label: this.$t('pay_order.dai_zhi_fuo', [waitPayNum]),
        },
        {
          name: 'paid',
          label: this.$t('pay_order.yi_zhi_fu'),
        },
      ];
    },
  },
  methods: {
    // 取消订单
    //   portalCancelPayment: '/fms/portal/cancelPayment', // [POST] {billPaymentCode} 取消支付订单
    onCancelOrder(row) {
      this.$showConfirm(this, this.$t('pay_order.nqdyqxxzdddm')).then(() => {
        const billPaymentCode = this.getPaymentCode(row);
        const url = `${apis.portalCancelPayment}/${billPaymentCode}`;
        this.$postJSON(url, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.onUpdate();
        });
      });
    },

    onUpdate() {
      this.getTableList();
      this.$emit('update');
    },

    // 撤销订单
    onRevokeOrder(row) {
      this.$showConfirm(this, this.$t('pay_order.nqdycxxzdddm')).then(() => {
        const billPaymentCode = this.getPaymentCode(row);
        const url = `${apis.portalRevoke}/${billPaymentCode}`;
        this.$postJSON(url, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.onUpdate();
        });
      });
    },

    // 格式化付款方式
    getTradeMethod(row) {
      const ret = [];
      const { tradeMethod, isUseBalance } = row;
      if (tradeMethod && this.dicValueName.payment_class) {
        const key = `${tradeMethod}`;
        ret.push(this.dicValueName.payment_class[key]);
      }
      if (isUseBalance) {
        ret.push(this.$t('pay_order.yu_e'));
      }
      return ret.join('+');
    },
    // 获取未支付数据
    async getWaitPayNum() {
      const res = await this.getTableList('wait', false);
      this.waitPayNum = res.data.total;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList(payType, updateTableList = true) {
      const reqData = this.getReqData(payType);
      return this.$getJSON(apis.portalMypaymentPage, reqData).then((res) => {
        if (updateTableList) {
          this.tableList = res.data.list || res.data.records;
          this.totalRows = res.data.total;
        }

        return res;
      });
    },
    getReqData(payType) {
      const ret = {
        ...this.formSearch,
      };
      const tradeState = tradeStateMap[payType || this.payType];
      ret.tradeState = tradeState;
      return ret;
    },
  },
  created() {},
  mounted() {
    this.payType = 'all';
    this.getFuncView('/rent/myAccount');
    this.getDictionaryValueName('payment_class', () => {
      this.getTableList();
      this.getWaitPayNum();
    });
  },
};
</script>

<style lang="scss" scoped>
.table-content {
  border-radius: 16px;
  background: #fff;
  > .header {
    padding: 24px;
    overflow: hidden;
    padding-bottom: 0;
    .tab-list {
      float: left;
    }
    .search-content {
      float: right;
    }
  }

  .table-bd {
    height: 416px;
    width: 100%;
    overflow: hidden;
    padding: 0 24px;
  }
}
</style>
